import Icon from '@/common/components/Icon';
import OrderedInfo from '../components/OrderedInfo';

export const getRaws = (data, onAdd) => {
	if (!data || !data[0]) {
		return;
	}

	return data.map((row) => (
		<tr key={row.queue_id}>
			<td>{row.queue_name}</td>
			<td>
				<OrderedInfo row={row} />
			</td>
			<td>{row.algorithm_yesterday_first || 0}</td>
			<td>{row.algorithm_yesterday_next || 0}</td>
			<td>{row.delivered_yesterday || 0}</td>
			<td>{row.delivered_three_days || 0}</td>
			<td>
				<Icon name='plus' size={16} onClick={() => onAdd(row.queue_id)} />
			</td>
		</tr>
	));
};
